import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ButtonUIComponent, IconUIComponent, LoadingUIComponent } from '@shared-ui-kit';
import { TranslatePipe } from '@ngx-translate/core';
import { OpenAPIApiService } from '@data-access';
import { firstValueFrom } from 'rxjs';
import { CoreService } from '../services/core.service';

@Component({
  selector: 'fr8bot-service-work-page',
  imports: [LoadingUIComponent, IconUIComponent, ButtonUIComponent, TranslatePipe],
  templateUrl: './service-work-page.html',
  styleUrl: './service-work-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceWorkPage {
  private apiService = inject(OpenAPIApiService);
  private coreService = inject(CoreService);

  isChecking = signal(false);

  async handlePing() {
    this.isChecking.set(true);

    try {
      await firstValueFrom(this.apiService.getApiStatus());
      window.location.reload();
    } catch {
      this.coreService.showError('errors.toastrErrors.serviceStillUnavailable');
    } finally {
      this.isChecking.set(false);
    }
  }
}
